<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2020-11-25 03:36:09
    Description : 素材root页面
  -->
  <div class="index">
    <gaia-header
      v-if="$route.path === '/gaia-48/update'"
      @upload="$refs.dialog.show()"
    />
    <gaia-header-48 v-else @upload="$refs.dialog.show()" />
    <router-view :key="$route.fullPath" />
    <gaia-footer />
    <materialDialog ref="dialog" />
  </div>
</template>
<script>
import gaiaHeader from "@/components/gaia-header/gaia-header";
import gaiaHeader48 from "@/components/gaia-header/gaia-48";
import GaiaFooter from "@/components/gaia-footer/gaia48-footer";
import materialDialog from "@/components/gaia-header/material-dialog";
export default {
  components: {
    gaiaHeader,
    gaiaHeader48,
    GaiaFooter,
    materialDialog,
  },
  created() {
    if (this.$route.path === "/gaia-48") {
      this.$router.push("/gaia-48/main");
    }
  },
};
</script>

<style lang="less" scoped>
</style>